module.exports = __webpack_public_path__ + "img/5e770b0495ba25351d01207c7f4b5b33.svg";